"use client";

import { useContext, useEffect } from "react";
import { AppContext } from "@/context/AppContext";
import { HomeFeatures } from "@/components/home/HomeFeatures";
import { HeroSection } from "@/components/home/HeroSection";
import { BrandsShowcase } from "@/components/home/BrandsShowcase";
import { StatsSection } from "@/components/home/StatsSection";
import { CtaSection } from "@/components/home/CtaSection";
import { HomeData } from "@/data/types";

interface HomePageClientProps {
  homeData: HomeData;
}

export function HomePageClient({ homeData }: HomePageClientProps) {
  const { setActivePage } = useContext(AppContext);

  useEffect(() => {
    setActivePage("home");
  }, [setActivePage]);

  return (
    <div className="max-w-7xl py-4 md:py-16 transition-all duration-400">
      <HeroSection homeData={homeData} />
      <HomeFeatures features={homeData.features} />
      <BrandsShowcase brandsData={homeData.brands} />
      <StatsSection stats={homeData.stats} />
      <CtaSection cta={homeData.cta} />
    </div>
  );
}